"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LoomI18n_1 = require("./LoomI18n");
Object.defineProperty(exports, "LoomI18n", { enumerable: true, get: function () { return LoomI18n_1.LoomI18n; } });
Object.defineProperty(exports, "Currency", { enumerable: true, get: function () { return LoomI18n_1.Currency; } });
//# sourceMappingURL=index.js.map